<template>
  <div class="question-radio">
    <span class="md-title">{{ question }}</span>
    <div v-for="item in options" v-bind:key="item.value">
        <md-radio v-model="value" :value="item.value" @click.native="event">
        {{ item.description }}
    </md-radio>
    </div>
    <transition name="zoom">
      <md-field v-if="bad">
        <label>Comentários*</label>
        <md-textarea v-model="context"></md-textarea>
      </md-field>
    </transition>
  </div>
</template>

<script>

export default {
  props: ['question', 'options', 'badValue'],
  model: {
    prop: 'value',
    event: 'change'
  },
  name: 'question-radio',
  data () {
    return {
      value: '',
      context: '',
      bad: false
    }
  },
  methods: {
    event () {
      this.$emit('change', this.value)
      this.bad = this.value === this.badValue
    }
  },
  watch: {
    context: function (val) {
      this.$emit('changeData', val)
    }
  }
}
</script>

<style lang="scss">
.question-radio {
  padding: 20px 20px;
  text-align: left;
}
.question {
  margin: 20px 20px;
}
.md-radio {
  display: flex;
  padding: 0px 20px;
}
</style>
